import { Box, Link, Stack, Typography } from '@mui/material';
import { backendServices } from 'common';
import { ReactNode, useMemo } from 'react';

function wrapAtAtSign(value: string): ReactNode {
    const atIndex = value.indexOf('@');
    if (atIndex === -1) {
        return value;
    }

    return (
        <>
            {value.slice(0, atIndex + 1)}
            <wbr />
            {value.slice(atIndex + 1)}
        </>
    );
}

export function ContactInformation({
    companyName,
    links: { InvitationLink, RegistrationContact },
}: {
    companyName: string;
    links: Pick<backendServices.ViewModels.CompanyViewModel, 'InvitationLink' | 'RegistrationContact'>;
}) {
    const invitationUrl = new URL(`/BuyerInvitation/${InvitationLink}`, window.location.origin);

    const formattedRegistrationContact = useMemo(() => {
        if (!RegistrationContact) {
            return '';
        }

        const isRegistrationContactEmail = RegistrationContact.includes('@');

        // If the registration contact is an email, return a mailto link
        if (isRegistrationContactEmail) {
            return `mailto:${RegistrationContact}`;
        }

        // otherwise, return the contact appended with an http:// if it doesn't already have it
        return RegistrationContact.includes('http') ? RegistrationContact : `http://${RegistrationContact}`;
    }, [RegistrationContact]);

    return (
        <Stack
            direction={{
                xs: 'row',
                lg: 'column',
            }}
            flexWrap="wrap"
            minWidth={0}
            gap={{
                xs: 3,
                md: 4,
            }}
        >
            {InvitationLink != null && (
                <Box>
                    <Typography variant="subtitle1" gutterBottom>
                        Invitation Details
                    </Typography>
                    <Link variant="subtitle2" href={invitationUrl.href} target="_blank">
                        Read Full Invitation
                    </Link>
                </Box>
            )}
            <Stack
                direction={{
                    xs: 'row',
                    lg: 'column',
                }}
                flexWrap="wrap"
                minWidth={0}
                gap={{
                    xs: 3,
                    md: 4,
                }}
            >
                {RegistrationContact && (
                    <Box sx={{ minWidth: 0, overflowWrap: 'break-word' }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Contact {companyName}
                        </Typography>
                        <Link href={formattedRegistrationContact} variant="subtitle2" target="_blank">
                            {wrapAtAtSign(RegistrationContact)}
                        </Link>
                    </Box>
                )}
                <Box>
                    <Typography variant="subtitle1" gutterBottom>
                        Contact Transcepta
                    </Typography>
                    <Link variant="subtitle2" href="https://support.transcepta.com" target="_blank">
                        support.transcepta.com
                    </Link>
                </Box>
            </Stack>
        </Stack>
    );
}
